import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Transaction } from "../state/types"

export const useTransactionActions = () => {
    const saveActions = useSaveActions()

    const saveTransaction = (transaction: Transaction) => {
        const { save } = saveActions()
        return save(TableName.TRANSACTIONS, transaction) as Promise<Transaction>
    }

    const removeTransactions = (ids: string[]) => {
        const { removeMultiple } = saveActions()
        return removeMultiple(TableName.TRANSACTIONS, ids)
    }

    return {
        saveTransaction,
        removeTransactions
    }
}
